export const VALID_RETURN_PATHS = ["/", "/archive", "/errors"];
